import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps2 } from 'intergalactic/core';
import { assignProps as _assignProps } from 'intergalactic/core';
var _excluded = ["position"];
import React from 'react';
import { findDOMNode } from 'react-dom';
import createComponent, { Component, sstyled, Root } from 'intergalactic/core';
import { Box } from 'intergalactic/flex-box';
import trottle from 'intergalactic/utils/lib/rafTrottle';
import { getNodeByRef } from 'intergalactic/utils/lib/ref';
import { isAdvanceMode } from 'intergalactic/utils/lib/findComponent';
import { callAllEventHandlers } from 'intergalactic/utils/lib/assignProps';
import BarRoot, { setAreaValue } from './ScrollBar';
import keyboardFocusEnhance from 'intergalactic/utils/lib/enhances/keyboardFocusEnhance';
import uniqueIDEnhancement from 'intergalactic/utils/lib/uniqueID';
import canUseDOM from 'intergalactic/utils/lib/canUseDOM';
/*__reshadow-styles__:"./style/scroll-area.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SScrollArea_m2jzo_gg_{position:relative;width:100%;height:100%}.___SShadowHorizontal_m2jzo_gg_:after,.___SShadowHorizontal_m2jzo_gg_:before,.___SShadowVertical_m2jzo_gg_:after,.___SShadowVertical_m2jzo_gg_:before{content:\"\";position:absolute;display:none;pointer-events:none}.___SShadowHorizontal_m2jzo_gg_:after,.___SShadowHorizontal_m2jzo_gg_:before{top:0;width:5px;height:100%}.___SShadowHorizontal_m2jzo_gg_._position_median_m2jzo_gg_:before{left:0;display:block;background:var(--intergalactic-scroll-area-shadow-left,\n    linear-gradient(to right, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_m2jzo_gg_._position_median_m2jzo_gg_:after{right:0;display:block;background:var(--intergalactic-scroll-area-shadow-right,\n    linear-gradient(to left, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_m2jzo_gg_._position_start_m2jzo_gg_:before{left:0;display:block;background:var(--intergalactic-scroll-area-shadow-left,\n    linear-gradient(to right, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_m2jzo_gg_._position_end_m2jzo_gg_:after{right:0;display:block;background:var(--intergalactic-scroll-area-shadow-right,\n    linear-gradient(to left, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_m2jzo_gg_.__leftOffset_m2jzo_gg_:before{left:var(--leftOffset_m2jzo)}.___SShadowHorizontal_m2jzo_gg_.__rightOffset_m2jzo_gg_:after{right:var(--rightOffset_m2jzo)}.___SShadowVertical_m2jzo_gg_:after,.___SShadowVertical_m2jzo_gg_:before{left:0;width:100%;height:5px}.___SShadowVertical_m2jzo_gg_._position_median_m2jzo_gg_:before{top:0;display:block;background:var(--intergalactic-scroll-area-shadow-top,\n    linear-gradient(to bottom, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_m2jzo_gg_._position_median_m2jzo_gg_:after{bottom:0;display:block;background:var(--intergalactic-scroll-area-shadow-bottom,\n    linear-gradient(to top, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_m2jzo_gg_._position_start_m2jzo_gg_:before{top:0;display:block;background:var(--intergalactic-scroll-area-shadow-top,\n    linear-gradient(to bottom, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_m2jzo_gg_._position_end_m2jzo_gg_:after{bottom:0;display:block;background:var(--intergalactic-scroll-area-shadow-bottom,\n    linear-gradient(to top, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_m2jzo_gg_.__topOffset_m2jzo_gg_:before{top:var(--topOffset_m2jzo)}.___SShadowVertical_m2jzo_gg_.__bottomOffset_m2jzo_gg_:after{bottom:var(--bottomOffset_m2jzo)}.___SContainer_m2jzo_gg_{display:block;width:100%;height:100%;box-sizing:content-box;overflow:auto;-webkit-overflow-scrolling:touch;outline:0;scrollbar-width:none;-ms-overflow-style:none}.___SContainer_m2jzo_gg_::-webkit-scrollbar{display:none}.___SContainer_m2jzo_gg_.__keyboardFocused_m2jzo_gg_:focus::after{position:absolute;display:block;content:\"\";top:0;right:0;bottom:0;left:0;top:var(--focusRingTopOffset_m2jzo);right:var(--focusRingRightOffset_m2jzo);bottom:var(--focusRingBottomOffset_m2jzo);left:var(--focusRingLeftOffset_m2jzo);box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5));pointer-events:none;z-index:2}" /*__inner_css_end__*/, "m2jzo_gg_") /*__reshadow_css_end__*/, {
  "__SScrollArea": "___SScrollArea_m2jzo_gg_",
  "__SShadowHorizontal": "___SShadowHorizontal_m2jzo_gg_",
  "_leftOffset": "__leftOffset_m2jzo_gg_",
  "--leftOffset": "--leftOffset_m2jzo",
  "_rightOffset": "__rightOffset_m2jzo_gg_",
  "--rightOffset": "--rightOffset_m2jzo",
  "__SShadowVertical": "___SShadowVertical_m2jzo_gg_",
  "_topOffset": "__topOffset_m2jzo_gg_",
  "--topOffset": "--topOffset_m2jzo",
  "_bottomOffset": "__bottomOffset_m2jzo_gg_",
  "--bottomOffset": "--bottomOffset_m2jzo",
  "__SContainer": "___SContainer_m2jzo_gg_",
  "_keyboardFocused": "__keyboardFocused_m2jzo_gg_",
  "--focusRingTopOffset": "--focusRingTopOffset_m2jzo",
  "--focusRingRightOffset": "--focusRingRightOffset_m2jzo",
  "--focusRingBottomOffset": "--focusRingBottomOffset_m2jzo",
  "--focusRingLeftOffset": "--focusRingLeftOffset_m2jzo",
  "_position_median": "_position_median_m2jzo_gg_",
  "_position_start": "_position_start_m2jzo_gg_",
  "_position_end": "_position_end_m2jzo_gg_"
});
var eventCalculate = undefined;
if (typeof window !== 'undefined') {
  eventCalculate = new Event('calculate');
}
var BoxWithoutPosition = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var position = _ref5.position,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, props));
});
var ScrollAreaRoot = /*#__PURE__*/function (_Component) {
  _inherits(ScrollAreaRoot, _Component);
  var _super = _createSuper(ScrollAreaRoot);
  function ScrollAreaRoot(props) {
    var _this;
    _classCallCheck(this, ScrollAreaRoot);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "$wrapper", null);
    _defineProperty(_assertThisInitialized(_this), "observer", null);
    _defineProperty(_assertThisInitialized(_this), "horizontalBarRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "verticalBarRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      shadowHorizontal: false,
      shadowVertical: false
    });
    _defineProperty(_assertThisInitialized(_this), "refWrapper", function (node) {
      _this.$wrapper = findDOMNode(node);
    });
    _defineProperty(_assertThisInitialized(_this), "setStyleSizeProperty", function (element, propertyKey, value) {
      var propertyValue = value;
      if (typeof value === 'number') {
        propertyValue = value < 1 ? "".concat(100 * value, "%") : "".concat(value, "px");
      }
      element.style.setProperty(propertyKey, propertyValue);
    });
    _defineProperty(_assertThisInitialized(_this), "calculate", trottle(function () {
      if (!_this.$container) return;
      var _this$calculateSizeCo = _this.calculateSizeContainer(),
        height = _this$calculateSizeCo.height,
        width = _this$calculateSizeCo.width;
      if (height) _this.$container.style.height = height;
      if (width) _this.$container.style.width = width;
      _this.$container.dispatchEvent(eventCalculate);
      _this.setShadowContainer();
    }));
    _defineProperty(_assertThisInitialized(_this), "updateBarsAria", trottle(function () {
      setAreaValue(_this.$container, _this.horizontalBarRef.current, _this.verticalBarRef.current);
    }));
    _defineProperty(_assertThisInitialized(_this), "handleScrollContainer", trottle(function () {
      if (!_this.$container) return;
      _this.setShadowContainer();
      _this.updateBarsAria();
    }));
    // FIX Chrome bug, when focus state on hide control
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (e) {
      var _e$target;
      if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.isEqualNode(_this.$wrapper)) {
        e.target.scrollTop = 0;
        e.target.scrollLeft = 0;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocusIn", function (e) {
      setTimeout(function () {
        var _this$asProps = _this.asProps,
          keyboardFocused = _this$asProps.keyboardFocused,
          leftOffset = _this$asProps.leftOffset,
          rightOffset = _this$asProps.rightOffset,
          topOffset = _this$asProps.topOffset,
          bottomOffset = _this$asProps.bottomOffset;
        if (_this.$container && typeof _this.$container.scrollTo === 'function') {
          var viewPort = _this.$container.getBoundingClientRect();
          var element = e.target.getBoundingClientRect();
          var offset = {
            top: topOffset !== null && topOffset !== void 0 ? topOffset : 0,
            left: leftOffset !== null && leftOffset !== void 0 ? leftOffset : 0,
            right: rightOffset !== null && rightOffset !== void 0 ? rightOffset : 0,
            bottom: bottomOffset !== null && bottomOffset !== void 0 ? bottomOffset : 0
          };
          if (viewPort) {
            var outOfViewport = Math.floor(element.top) >= viewPort.bottom - offset.bottom || Math.floor(element.bottom) <= viewPort.top + offset.top || Math.floor(element.left) >= viewPort.right - offset.right || Math.floor(element.right) <= viewPort.left + offset.left;
            if (outOfViewport && keyboardFocused) {
              _this.$container.scrollTo({
                top: element.top + _this.$container.scrollTop - offset.top - viewPort.top,
                left: element.left + _this.$container.scrollLeft - offset.left - viewPort.left
              });
            }
          }
        }
      }, 0);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleShadow", function (scroll, maxScroll, orientation) {
      var roundedScroll = Math.round(scroll);
      var roundedMaxScroll = Math.round(maxScroll);
      var shadow = '';
      // not scroll
      if (roundedMaxScroll <= 0) {
        // start scroll
      } else if (roundedScroll <= 0) {
        shadow = 'end';
        // end scroll
      } else if (roundedScroll >= roundedMaxScroll) {
        shadow = 'start';
        // median scroll
      } else if (roundedScroll > 0) {
        shadow = 'median';
      }
      _this.setState(_defineProperty({}, orientation, shadow));
    });
    _defineProperty(_assertThisInitialized(_this), "setShadowContainer", function () {
      if (!_this.asProps.shadow || !_this.$container || !_this.$wrapper) return;
      var _this$$container = _this.$container,
        scrollWidth = _this$$container.scrollWidth,
        clientWidth = _this$$container.clientWidth,
        scrollHeight = _this$$container.scrollHeight,
        clientHeight = _this$$container.clientHeight,
        scrollLeft = _this$$container.scrollLeft,
        scrollTop = _this$$container.scrollTop;
      var maxScrollRight = scrollWidth - clientWidth;
      var maxScrollBottom = scrollHeight - clientHeight;
      _this.toggleShadow(scrollLeft, maxScrollRight, 'shadowHorizontal');
      _this.toggleShadow(scrollTop, maxScrollBottom, 'shadowVertical');
    });
    if (canUseDOM()) {
      _this.observer = new ResizeObserver(callAllEventHandlers(props.onResize, _this.calculate));
    }
    return _this;
  }
  _createClass(ScrollAreaRoot, [{
    key: "$container",
    get: function get() {
      return getNodeByRef(this.asProps.container);
    }
  }, {
    key: "$inner",
    get: function get() {
      return getNodeByRef(this.asProps.inner);
    }
  }, {
    key: "calculateSizeContainer",
    value:
    // for max height/width
    function calculateSizeContainer() {
      var _this$asProps2 = this.asProps,
        wMax = _this$asProps2.wMax,
        hMax = _this$asProps2.hMax,
        observeParentSize = _this$asProps2.observeParentSize;
      var size = {
        width: '',
        height: ''
      };
      if (!this.$container || !this.$wrapper) return size;
      var _this$$container2 = this.$container,
        scrollWidth = _this$$container2.scrollWidth,
        scrollHeight = _this$$container2.scrollHeight;
      var style = window.getComputedStyle(this.$wrapper);
      var parent = this.$wrapper.parentElement;
      var parentRect = {
        width: 0,
        height: 0
      };
      if (observeParentSize) {
        if (parent) {
          parentRect = parent.getBoundingClientRect();
        }
        if (wMax) this.setStyleSizeProperty(this.$wrapper, 'max-width', wMax);
        if (hMax) this.setStyleSizeProperty(this.$wrapper, 'max-height', hMax);
      }
      var maxWidth = Number.parseInt(style.getPropertyValue('max-width'));
      var maxHeight = Number.parseInt(style.getPropertyValue('max-height'));
      if (maxWidth) {
        if (observeParentSize && wMax && parent.scrollWidth > parentRect.width) {
          /** even if width is like 100.486px we should round it to 100, not 101 */
          var diff = Math.round(parent.scrollWidth.toFixed(1)) - Math.round(parentRect.width.toFixed(1));
          if (diff < maxWidth) {
            maxWidth = maxWidth - diff;
            this.$wrapper.style.setProperty('max-width', "".concat(maxWidth, "px"));
          }
        }
        if (scrollWidth > maxWidth) {
          size.width = "".concat(maxWidth, "px");
        } else {
          size.width = '100%';
        }
      }
      if (maxHeight) {
        if (observeParentSize && hMax && parent.scrollHeight > parentRect.height) {
          /** even if height is like 100.486px we should round it to 100, not 101 */
          var _diff = Math.round(parent.scrollHeight.toFixed(1)) - Math.round(parentRect.height.toFixed(1));
          if (_diff < maxHeight) {
            maxHeight = maxHeight - _diff;
            this.$wrapper.style.setProperty('max-height', "".concat(maxHeight, "px"));
          }
        }
        if (scrollHeight > maxHeight) {
          size.height = "".concat(maxHeight, "px");
        } else {
          size.height = '100%';
        }
      }
      return size;
    }
  }, {
    key: "getContainerProps",
    value: function getContainerProps() {
      var _this$asProps3 = this.asProps,
        container = _this$asProps3.container,
        inner = _this$asProps3.inner,
        onScroll = _this$asProps3.onScroll,
        uid = _this$asProps3.uid;
      return {
        id: "igc-".concat(uid, "-scroll-container"),
        ref: container,
        $refInner: inner,
        onScroll: callAllEventHandlers(onScroll, this.handleScrollContainer)
      };
    }
  }, {
    key: "getBarProps",
    value: function getBarProps() {
      var _this$asProps4 = this.asProps,
        container = _this$asProps4.container,
        orientation = _this$asProps4.orientation,
        uid = _this$asProps4.uid,
        leftOffset = _this$asProps4.leftOffset,
        rightOffset = _this$asProps4.rightOffset;
      return {
        container: container,
        orientation: orientation,
        uid: uid,
        horizontalBarRef: this.horizontalBarRef,
        verticalBarRef: this.verticalBarRef,
        leftOffset: leftOffset,
        rightOffset: rightOffset
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$$inner;
      this.calculate();
      this.updateBarsAria();
      if (this.$inner) {
        var _this$observer;
        (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.observe(this.$inner);
      }
      if (this.$container) {
        var _this$observer2;
        (_this$observer2 = this.observer) === null || _this$observer2 === void 0 ? void 0 : _this$observer2.observe(this.$container);
      }
      (_this$$inner = this.$inner) === null || _this$$inner === void 0 ? void 0 : _this$$inner.addEventListener('focusin', this.handleFocusIn);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.calculate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$observer3, _this$$inner2;
      (_this$observer3 = this.observer) === null || _this$observer3 === void 0 ? void 0 : _this$observer3.disconnect();
      (_this$$inner2 = this.$inner) === null || _this$$inner2 === void 0 ? void 0 : _this$$inner2.removeEventListener('focusin', this.handleFocusIn);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps,
        _ref3;
      var SScrollArea = Box;
      var SShadowVertical = BoxWithoutPosition;
      var SShadowHorizontal = BoxWithoutPosition;
      var _this$asProps5 = this.asProps,
        Children = _this$asProps5.Children,
        styles = _this$asProps5.styles,
        orientation = _this$asProps5.orientation,
        tabIndex = _this$asProps5.tabIndex,
        forcedAdvancedMode = _this$asProps5.forcedAdvancedMode,
        leftOffset = _this$asProps5.leftOffset,
        rightOffset = _this$asProps5.rightOffset,
        topOffset = _this$asProps5.topOffset,
        bottomOffset = _this$asProps5.bottomOffset;
      var _this$state = this.state,
        shadowVertical = _this$state.shadowVertical,
        shadowHorizontal = _this$state.shadowHorizontal;
      var advancedMode = forcedAdvancedMode || isAdvanceMode(Children, [ScrollArea.Container.displayName, ScrollArea.Bar.displayName]);
      return _ref3 = sstyled(styles), /*#__PURE__*/React.createElement(SScrollArea, _ref3.cn("SScrollArea", _objectSpread({}, _assignProps({
        "ref": this.refWrapper,
        "onScroll": this.handleScroll,
        "__excludeProps": ['tabIndex']
      }, _ref))), advancedMode ? /*#__PURE__*/React.createElement(Children, _ref3.cn("Children", {})) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollArea.Container, {
        tabIndex: tabIndex
      }, /*#__PURE__*/React.createElement(Children, _ref3.cn("Children", {}))), (orientation === undefined || orientation === 'horizontal') && /*#__PURE__*/React.createElement(ScrollArea.Bar, {
        orientation: "horizontal"
      }), (orientation === undefined || orientation === 'vertical') && /*#__PURE__*/React.createElement(ScrollArea.Bar, {
        orientation: "vertical"
      })), shadowVertical && /*#__PURE__*/React.createElement(SShadowVertical, _ref3.cn("SShadowVertical", {
        "position": shadowVertical,
        "topOffset": topOffset ? "".concat(topOffset, "px") : undefined,
        "bottomOffset": bottomOffset ? "".concat(bottomOffset, "px") : undefined
      })), shadowHorizontal && /*#__PURE__*/React.createElement(SShadowHorizontal, _ref3.cn("SShadowHorizontal", {
        "position": shadowHorizontal,
        "leftOffset": leftOffset ? "".concat(leftOffset, "px") : undefined,
        "rightOffset": rightOffset ? "".concat(rightOffset, "px") : undefined
      })));
    }
  }]);
  return ScrollAreaRoot;
}(Component);
_defineProperty(ScrollAreaRoot, "displayName", 'ScrollArea');
_defineProperty(ScrollAreaRoot, "style", style);
_defineProperty(ScrollAreaRoot, "enhance", [uniqueIDEnhancement(), keyboardFocusEnhance()]);
_defineProperty(ScrollAreaRoot, "defaultProps", function () {
  return {
    container: /*#__PURE__*/React.createRef(),
    inner: /*#__PURE__*/React.createRef(),
    tabIndex: 0,
    observeParentSize: false
  };
});
function ContainerRoot(props) {
  var _ref2 = arguments[0],
    _ref4;
  var SContainer = Box;
  var Children = props.Children,
    styles = props.styles,
    $refInner = props.$refInner,
    _props$focusRingTopOf = props.focusRingTopOffset,
    focusRingTopOffset = _props$focusRingTopOf === void 0 ? 0 : _props$focusRingTopOf,
    _props$focusRingRight = props.focusRingRightOffset,
    focusRingRightOffset = _props$focusRingRight === void 0 ? 0 : _props$focusRingRight,
    _props$focusRingBotto = props.focusRingBottomOffset,
    focusRingBottomOffset = _props$focusRingBotto === void 0 ? 0 : _props$focusRingBotto,
    _props$focusRingLeftO = props.focusRingLeftOffset,
    focusRingLeftOffset = _props$focusRingLeftO === void 0 ? 0 : _props$focusRingLeftO;
  return _ref4 = sstyled(styles), /*#__PURE__*/React.createElement(SContainer, _ref4.cn("SContainer", _objectSpread({}, _assignProps2({
    "tabIndex": 0,
    "focusRingTopOffset": focusRingTopOffset,
    "focusRingRightOffset": focusRingRightOffset,
    "focusRingBottomOffset": focusRingBottomOffset,
    "focusRingLeftOffset": focusRingLeftOffset
  }, _ref2))), /*#__PURE__*/React.createElement("div", _ref4.cn("div", {
    "ref": $refInner
  }), /*#__PURE__*/React.createElement(Children, _ref4.cn("Children", {}))));
}
ContainerRoot.enhance = [keyboardFocusEnhance()];
var ScrollArea = createComponent(ScrollAreaRoot, {
  Container: ContainerRoot,
  Bar: BarRoot
});

// TODO: remove named ScrollArea export
export { eventCalculate, ScrollArea };
export default ScrollArea;
//# sourceMappingURL=ScrollArea.js.map